import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/view/home.vue'
import Login from '@/view/login.vue' 
import Menu from '@/view/menu.vue' 
import Photos from '@/view/photos.vue' 
import CodeQr from '@/view/codeQr.vue' 
import OrderFood from '@/view/orderFood.vue' 
import ChoiceFood from '@/view/choiceFood.vue' 
import OrderPlaced from '@/view/orderPlaced.vue' 
import Myinfo from '@/view/myinfo.vue' 
import Bind from '@/view/bind.vue' 
import MealTicket from '@/view/mealTicket.vue' 
import MeaList from '@/view/meaList.vue' 
import TopUp from '@/view/topUp.vue' 
import TopUpPay from '@/view/topUpPay.vue' 
import TopUpList from '@/view/topUpList.vue' 
import Appointment from '@/view/appointment.vue' 
import OrderHistory from '@/view/orderHistory.vue' 
import OrderDetal from '@/view/orderDetal.vue' 
import AddresList from '@/view/addresList.vue' 
import AddresDetal from '@/view/addresDetal.vue' 
import MyNew from '@/view/myNew.vue' 
import Service from '@/view/service.vue' 
import System from '@/view/system.vue' 
import Password from '@/view/password.vue' 
import Phone from '@/view/phone.vue' 
import Email from '@/view/email.vue' 



Vue.use(Router)

export default new Router({
	mode: 'history', // 使用 history 模式
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect: 'menu',
      children: [
		  {
		    path: '/menu',
		    name: 'menu',
		    component: Menu,
		  },
        {
          path: '/login',
          name: 'login',
          component: Login,
        },
		
		{
		  path: '/photos',
		  name: 'photos',
		  component: Photos,
		},
		{
		  path: '/codeQr',
		  name: 'codeQr',
		  component: CodeQr,
		},
		{
		  path: '/orderFood',
		  name: 'orderFood',
		  component: OrderFood,
		},
		{
		  path: '/choiceFood',
		  name: 'choiceFood',
		  component: ChoiceFood,
		},
		{
		  path: '/orderPlaced',
		  name: 'orderPlaced',
		  component: OrderPlaced,
		},
		{
		  path: '/myinfo',
		  name: 'myinfo',
		  component: Myinfo,
		},
		{
		  path: '/bind',
		  name: 'bind',
		  component: Bind,
		},
		{
		  path: '/mealTicket',
		  name: 'mealTicket',
		  component: MealTicket,
		},
		{
		  path: '/meaList',
		  name: 'meaList',
		  component: MeaList,
		},
		{
		  path: '/topUp',
		  name: 'topUp',
		  component: TopUp,
		},
		{
		  path: '/topUpPay',
		  name: 'topUpPay',
		  component: TopUpPay,
		},
		{
		  path: '/topUpList',
		  name: 'topUpList',
		  component: TopUpList,
		},
		{
		  path: '/appointment',
		  name: 'appointment',
		  component: Appointment,
		},
		{
		  path: '/orderHistory',
		  name: 'orderHistory',
		  component: OrderHistory,
		},
		{
		  path: '/orderDetal',
		  name: 'orderDetal',
		  component: OrderDetal,
		},
		{
		  path: '/addresList',
		  name: 'addresList',
		  component: AddresList,
		},
		{
		  path: '/addresDetal',
		  name: 'addresDetal',
		  component: AddresDetal,
		},
		{
		  path: '/myNew',
		  name: 'myNew',
		  component: MyNew,
		},
		{
		  path: '/service',
		  name: 'service',
		  component: Service,
		},
		{
		  path: '/system',
		  name: 'system',
		  component: System,
		},
		{
		  path: '/password',
		  name: 'password',
		  component: Password,
		},
		{
		  path: '/phone',
		  name: 'phone',
		  component: Phone,
		},
		{
		  path: '/email',
		  name: 'email',
		  component: Email,
		},
		
		
		//   path: '/submit/:type',
		//   name: 'submit',
		//   component: Submit,
	
      ]
    },
  ]
})